import type { Org } from "~/core/api";

/**
 * What pressing the balance offers: packs on a live plan, the plan otherwise,
 * nothing for somebody who may not spend the account's money.
 *
 * The same split the refusal listener makes between running out of credits and
 * a plan that lapsed. A pack is sold only to a live plan, so offering one to an
 * account without a plan opens a dialog whose every button is disabled.
 */
type BalanceAction = "top-up" | "plan" | null;

export function balanceAction(org: Pick<Org, "subscription_state">, canPay: boolean): BalanceAction {
	if (!canPay) return null;
	return org.subscription_state === "active" ? "top-up" : "plan";
}
